import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, AlertTriangleIcon } from 'lucide-react';
export function Urgency() {
  // Start at 23:59:27
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 27
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-12 px-4 bg-dark-card border-y border-brand-DEFAULT" data-id="element-320">
      <div className="max-w-4xl mx-auto text-center" data-id="element-321">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col items-center space-y-6" data-id="element-322">
          <div className="flex items-center space-x-2 text-white font-bold text-xl md:text-2xl" data-id="element-323">
            <ClockIcon size={28} className="text-brand-DEFAULT" data-id="element-324" />
            <span data-id="element-325">El precio de lanzamiento termina en:</span>
          </div>

          <div className="flex space-x-4" data-id="element-326">
            <div className="bg-dark-DEFAULT border border-dark-border text-brand-DEFAULT rounded-lg p-4 min-w-[80px]" data-id="element-327">
              <div className="text-4xl font-bebas" data-id="element-328">
                {timeLeft.hours.toString().padStart(2, '0')}
              </div>
              <div className="text-xs text-text-secondary uppercase tracking-wider" data-id="element-329">
                hs
              </div>
            </div>
            <div className="text-4xl font-bebas text-brand-DEFAULT self-center" data-id="element-330">
              :
            </div>
            <div className="bg-dark-DEFAULT border border-dark-border text-brand-DEFAULT rounded-lg p-4 min-w-[80px]" data-id="element-331">
              <div className="text-4xl font-bebas" data-id="element-332">
                {timeLeft.minutes.toString().padStart(2, '0')}
              </div>
              <div className="text-xs text-text-secondary uppercase tracking-wider" data-id="element-333">
                min
              </div>
            </div>
            <div className="text-4xl font-bebas text-brand-DEFAULT self-center" data-id="element-334">
              :
            </div>
            <div className="bg-dark-DEFAULT border border-dark-border text-brand-DEFAULT rounded-lg p-4 min-w-[80px]" data-id="element-335">
              <div className="text-4xl font-bebas" data-id="element-336">
                {timeLeft.seconds.toString().padStart(2, '0')}
              </div>
              <div className="text-xs text-text-secondary uppercase tracking-wider" data-id="element-337">
                seg
              </div>
            </div>
          </div>

          <div className="flex items-center space-x-2 text-white bg-dark-DEFAULT border border-dark-border px-4 py-2 rounded-full font-medium" data-id="element-338">
            <AlertTriangleIcon size={18} className="text-brand-DEFAULT" data-id="element-339" />
            <span data-id="element-340">Después sube USD 5 y no vuelve a bajar.</span>
          </div>

          <div className="w-full max-w-md mt-6" data-id="element-341">
            <div className="flex justify-between text-white font-bold text-sm mb-2" data-id="element-342">
              <span className="flex items-center" data-id="element-343">
                <span className="w-2 h-2 rounded-full bg-brand-DEFAULT mr-2" data-id="element-344"></span>
                Cupos al precio de lanzamiento
              </span>
              <span data-id="element-345">Quedan pocos</span>
            </div>
            <div className="h-3 bg-dark-DEFAULT border border-dark-border rounded-full overflow-hidden" data-id="element-346">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              delay: 0.5
            }} className="h-full bg-brand-DEFAULT rounded-full" data-id="element-347"></motion.div>
            </div>
            <div className="text-right text-text-secondary font-bold text-xs mt-1" data-id="element-348">
              68% de los cupos tomados
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}